<div class="batch-card">

  <div class="size">
    <span>{{stock.size}}</span>
    <span>{{"Size"|translate}}</span>
  </div>

  <div class="body">
    <span class="store-info">
      {{stock.storeStocks.storeName}}&nbsp;{{stock.storeStocks.store}}
      <!-- <br> -->
      <span class="batch">{{stock.batch}}</span>
    </span>

    <div class="batch-info">

      <span class="price">
        <span>{{sharedServices.getFormattedPrice(stock.price, stock.currency)}}</span>
        <span>{{(stock.vatIncluded ? "Including Taxes" : "Excluding Taxes")|translate}}</span>
      </span>

      <div class="stock-info">
        <span class="counter">
          <span>F</span>
          <span>{{stock.storeStocks.mainStock.free}}</span>
        </span>
        <span>&nbsp;|&nbsp;</span>
        <span class="counter">
          <span>R</span>
          <span>{{stock.storeStocks.mainStock.reservation}}</span>
        </span>
        <span>&nbsp;|&nbsp;</span>
        <span class="counter">
          <span>C</span>
          <span>{{stock.storeStocks.mainStock.consignment}}</span>
        </span>
      </div>

    </div>
  </div>

  <button class="btn" (click)="handleSelectStock.emit(stock)">
    <i class="bi bi-chevron-right"></i>
  </button>

</div>
